import { render, staticRenderFns } from "./addPermissionsForm.vue?vue&type=template&id=7691338f&"
import script from "./addPermissionsForm.vue?vue&type=script&lang=ts&"
export * from "./addPermissionsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports